import { Record } from 'immutable'

const ChannelMembershipRecord = Record(
  {
    id: '',
    role: 'reader',
    subject: null,
  },
  'channelMembership'
)

export default ChannelMembershipRecord
